import React from 'react';
import { css } from 'styled-components';
import { Helmet } from 'react-helmet';
import { FONTS } from './BaseFonts';
import { COLORS } from './BaseColors';
import { SHARED_VARIABLES_REFERENCE_OBJECT } from './SharedVariablesReferenceObject';
export var TYPOGRAPHY_CLASSNAMES = {
  H1: 'typography-h1',
  H2: 'typography-h2',
  H3: 'typography-h3',
  H4: 'typography-h4',
  H5: 'typography-h5',
  H6: 'typography-h6',
  XL: 'typography-xl',
  L: 'typography-l',
  M: 'typography-m',
  M_SEMIBOLD: 'typography-m-semibold',
  M_BOLD: 'typography-m-bold',
  S: 'typography-s',
  S_SEMIBOLD: 'typography-s-semibold',
  S_BOLD: 'typography-s-bold',
  XS: 'typography-xs',
  XS_BOLD: 'typography-xs-bold',
  INPUT: 'typography-input',
  INPUT_SEMIBOLD: 'typography-input-semibold'
};
var Headers = /*#__PURE__*/css(["", ";font-weight:700;letter-spacing:0;font-style:normal;color:", ";"], FONTS.SECONDARY, COLORS.NEUTRAL_600);
var Body = /*#__PURE__*/css(["", ";font-weight:400;letter-spacing:0;font-style:normal;color:", ";"], FONTS.PRIMARY, COLORS.NEUTRAL_600);
var SemiBold = /*#__PURE__*/css(["font-weight:500;"]);
var Bold = /*#__PURE__*/css(["font-weight:700;"]);
export var TYPOGRAPHY_BASE = {
  H1: css(["", ";font-size:5.5rem;line-height:calc(48 / 55);"], Headers),
  H2: css(["", ";font-size:4.4rem;line-height:calc(48 / 44);"], Headers),
  H3: css(["", ";font-size:3.5rem;line-height:calc(41 / 35);"], Headers),
  H4: css(["", ";font-size:2.8rem;line-height:calc(40 / 28);"], Headers),
  H5: css(["", ";font-size:2.3rem;line-height:calc(32 / 23);"], Headers),
  H6: css(["", ";font-size:1.7rem;line-height:calc(24 / 17);"], Headers),
  XL: css(["", ";font-size:2.5rem;line-height:calc(32 / 25);"], Body),
  L: css(["", ";font-size:2rem;line-height:calc(32 / 20);"], Body),
  M: css(["", ";font-size:1.6rem;line-height:calc(24 / 16);"], Body),
  M_SEMIBOLD: css(["", ";", ";font-size:1.6rem;line-height:calc(24 / 16);"], Body, SemiBold),
  M_BOLD: css(["", ";", ";font-size:1.6rem;line-height:calc(24 / 16);"], Body, Bold),
  S: css(["", ";font-size:1.3rem;line-height:calc(24 / 13);"], Body),
  S_SEMIBOLD: css(["", ";", ";font-size:1.3rem;line-height:calc(24 / 13);"], Body, SemiBold),
  S_BOLD: css(["", ";", ";font-size:1.3rem;line-height:calc(24 / 13);"], Body, Bold),
  XS: css(["", ";font-size:1rem;line-height:calc(16 / 10);"], Body),
  XS_BOLD: css(["", ";", ";font-size:1rem;line-height:calc(16 / 10);"], Body, Bold),
  INPUT: css(["", ";font-size:1.6rem;line-height:calc(24 / 16);"], Body),
  INPUT_SEMIBOLD: css(["", ";", ";font-size:1.6rem;line-height:calc(24 / 16);"], Body, SemiBold)
};
export var baseTypographyHeaders = /*#__PURE__*/css(["", ",h1{", ";}", ",h2{", ";}", ",h3{", ";}", ",h4{", ";}", ",h5{", ";}", ",h6{", ";}"], ".".concat(TYPOGRAPHY_CLASSNAMES.H1), TYPOGRAPHY_BASE.H1, ".".concat(TYPOGRAPHY_CLASSNAMES.H2), TYPOGRAPHY_BASE.H2, ".".concat(TYPOGRAPHY_CLASSNAMES.H3), TYPOGRAPHY_BASE.H3, ".".concat(TYPOGRAPHY_CLASSNAMES.H4), TYPOGRAPHY_BASE.H4, ".".concat(TYPOGRAPHY_CLASSNAMES.H5), TYPOGRAPHY_BASE.H5, ".".concat(TYPOGRAPHY_CLASSNAMES.H6), TYPOGRAPHY_BASE.H6);
export var baseTypographyHeadersNoDefault = /*#__PURE__*/css(["", "{", ";}", "{", ";}", "{", ";}", "{", ";}", "{", ";}", "{", ";}"], ".".concat(TYPOGRAPHY_CLASSNAMES.H1), TYPOGRAPHY_BASE.H1, ".".concat(TYPOGRAPHY_CLASSNAMES.H2), TYPOGRAPHY_BASE.H2, ".".concat(TYPOGRAPHY_CLASSNAMES.H3), TYPOGRAPHY_BASE.H3, ".".concat(TYPOGRAPHY_CLASSNAMES.H4), TYPOGRAPHY_BASE.H4, ".".concat(TYPOGRAPHY_CLASSNAMES.H5), TYPOGRAPHY_BASE.H5, ".".concat(TYPOGRAPHY_CLASSNAMES.H6), TYPOGRAPHY_BASE.H6);
export var baseTypography = /*#__PURE__*/css(["", "{", ";}", "{", ";}", "{", ";}", "{", ";}", ",p,ol,ul,li,tr,th,td,input,label{", ";}", "{", ";}", "{", ";}", "{", ";}", "{", ";}", "{", ";}", "{", ";}"], ".".concat(TYPOGRAPHY_CLASSNAMES.XL), TYPOGRAPHY_BASE.XL, ".".concat(TYPOGRAPHY_CLASSNAMES.L), TYPOGRAPHY_BASE.L, ".".concat(TYPOGRAPHY_CLASSNAMES.M), TYPOGRAPHY_BASE.M, ".".concat(TYPOGRAPHY_CLASSNAMES.M_SEMIBOLD), TYPOGRAPHY_BASE.M_SEMIBOLD, ".".concat(TYPOGRAPHY_CLASSNAMES.S), TYPOGRAPHY_BASE.S, ".".concat(TYPOGRAPHY_CLASSNAMES.S_SEMIBOLD), TYPOGRAPHY_BASE.S_SEMIBOLD, ".".concat(TYPOGRAPHY_CLASSNAMES.S_BOLD), TYPOGRAPHY_BASE.S_BOLD, ".".concat(TYPOGRAPHY_CLASSNAMES.XS), TYPOGRAPHY_BASE.XS, ".".concat(TYPOGRAPHY_CLASSNAMES.XS_BOLD), TYPOGRAPHY_BASE.XS_BOLD, ".".concat(TYPOGRAPHY_CLASSNAMES.INPUT), TYPOGRAPHY_BASE.INPUT, ".".concat(TYPOGRAPHY_CLASSNAMES.INPUT_SEMIBOLD), TYPOGRAPHY_BASE.INPUT_SEMIBOLD);
export var baseTypographyNoDefault = /*#__PURE__*/css(["", "{", ";}", "{", ";}", "{", ";}", "{", ";}", "{", ";}", "{", ";}", "{", ";}", "{", ";}", "{", ";}", "{", ";}", "{", ";}"], ".".concat(TYPOGRAPHY_CLASSNAMES.XL), TYPOGRAPHY_BASE.XL, ".".concat(TYPOGRAPHY_CLASSNAMES.L), TYPOGRAPHY_BASE.L, ".".concat(TYPOGRAPHY_CLASSNAMES.M), TYPOGRAPHY_BASE.M, ".".concat(TYPOGRAPHY_CLASSNAMES.M_SEMIBOLD), TYPOGRAPHY_BASE.M_SEMIBOLD, ".".concat(TYPOGRAPHY_CLASSNAMES.S), TYPOGRAPHY_BASE.S, ".".concat(TYPOGRAPHY_CLASSNAMES.S_SEMIBOLD), TYPOGRAPHY_BASE.S_SEMIBOLD, ".".concat(TYPOGRAPHY_CLASSNAMES.S_BOLD), TYPOGRAPHY_BASE.S_BOLD, ".".concat(TYPOGRAPHY_CLASSNAMES.XS), TYPOGRAPHY_BASE.XS, ".".concat(TYPOGRAPHY_CLASSNAMES.XS_BOLD), TYPOGRAPHY_BASE.XS_BOLD, ".".concat(TYPOGRAPHY_CLASSNAMES.INPUT), TYPOGRAPHY_BASE.INPUT, ".".concat(TYPOGRAPHY_CLASSNAMES.INPUT_SEMIBOLD), TYPOGRAPHY_BASE.INPUT_SEMIBOLD);
/**
 * This is mapped to the actual theme typography in ./SharedVariables.ts {@link baseVariables}
 * Onboarding themes uses the base values above.
 */

export var TYPOGRAPHY = SHARED_VARIABLES_REFERENCE_OBJECT.TYPOGRAPHY;

var _ref = /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("link", {
  rel: "preload",
  href: "https://fonts.googleapis.com/css?family=Gothic+A1:400,500,700|Poppins:700",
  as: "style"
}), /*#__PURE__*/React.createElement("link", {
  href: "https://fonts.googleapis.com/css?family=Gothic+A1:400,500,700|Poppins:700",
  rel: "stylesheet"
}));

export var BaseTypographyLoader = function BaseTypographyLoader() {
  return _ref;
};
/**
 * @deprecated as of 1.3.0
 */

export var addTypography = function addTypography(fontClassName, className) {
  if (!TYPOGRAPHY_CLASSNAMES[fontClassName]) console.error("Invalid fontClassName ".concat(fontClassName));
  return "".concat(TYPOGRAPHY_CLASSNAMES[fontClassName]).concat(className ? " ".concat(className) : '');
};